import { LongLogoLink } from './LongLogoLink';
import { LogoShortLink } from './LogoShortLink';
import { breakpoints } from '../../tokens/breakpoints';
import styled from 'styled-components';

const LogoLongLinkWrapper = styled.div`
  display: flex;
  @media (max-width: ${breakpoints.mobileMax}px) {
    display: none;
  }
`;

const LogoShortLinkWrapper = styled.div`
  display: none;
  @media (max-width: ${breakpoints.mobileMax}px) {
    display: flex;
  }
`;

/**
 * Long logo on wider screens, short logo on narrower screens
 */
export function LogoLink() {
  return (
    <>
      <LogoLongLinkWrapper>
        <LongLogoLink />
      </LogoLongLinkWrapper>
      <LogoShortLinkWrapper>
        <LogoShortLink />
      </LogoShortLinkWrapper>
    </>
  );
}
